/*@ngInject*/
const FieldDetailsModalController = function ($rootScope, $scope, options, coreConstant, localization) {

    $scope.viewModel = {
        fieldStructure: options.fieldStructure,
        formStructure: options.formStructure,
        agencyEditableFieldLevelString: '',
        carrierEditableFieldLevelString: '',
        requiredFieldLevelString: '',
        formEditableFieldLevelString: '',
        formRequiredFieldLevelString: ''
    };

    localization.getTranslationByKey('formsViewer.editableFieldLevel.' + $scope.viewModel.fieldStructure.uiField.fieldTemplate.agencyEditableFieldLevel).then(function (translation) {
        $scope.viewModel.agencyEditableFieldLevelString = translation;
    });

    localization.getTranslationByKey('formsViewer.editableFieldLevel.' + $scope.viewModel.fieldStructure.uiField.fieldTemplate.carrierEditableFieldLevel).then(function (translation) {
        $scope.viewModel.carrierEditableFieldLevelString = translation;
    });

    localization.getTranslationByKey('formsViewer.requiredFieldLevel.' + $scope.viewModel.fieldStructure.uiField.fieldTemplate.requiredFieldLevel).then(function (translation) {
        $scope.viewModel.requiredFieldLevelString = translation;
    });

    localization.getTranslationByKey('formsViewer.editableFieldLevel.' + $scope.viewModel.fieldStructure.parentForm.editableFieldLevel).then(function (translation) {
        $scope.viewModel.formEditableFieldLevelString = translation;
    });

    localization.getTranslationByKey('formsViewer.requiredFieldLevel.' + $scope.viewModel.fieldStructure.parentForm.requiredFieldLevel).then(function (translation) {
        $scope.viewModel.formRequiredFieldLevelString = translation;
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umFormViewer')
    .controller('fieldDetailsModalController', FieldDetailsModalController);
